import { getUser } from "$lib/userstorage/usersotrage"
import { handleAuthenticatedRequest, jsonOrThrow } from "../errores/erroresback"

let ruta_java = import.meta.env.VITE_RUTA_JAVA_SERVER;
let ruta_local_java = import.meta.env.VITE_RUTA_LOCAL_JAVA_SERVER;
let bd_local = import.meta.env.VITE_LOCAL_BD == "si";
let RUTA_JAVA = bd_local ? ruta_local_java : ruta_java
const RUTA_REPORTES = "reports"

// Reporte de Stock. El backend devuelve todo ya agregado (cards + lotes + rodeos + totales),
// con el mismo shape que consume la pantalla. Contrato: reportes/reportes-stock-backend.md
export async function getStock() {
    let ruta = `${RUTA_JAVA}${RUTA_REPORTES}/stock`
    let user = getUser();
    let token = user.token;
    let options = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }
    let res = await handleAuthenticatedRequest(ruta, options)
    let data = await jsonOrThrow(res, "reportes.getStock")
    return {
        categorias: data.categorias ?? [],
        lotes: data.lotes ?? [],
        rodeos: data.rodeos ?? [],
        totalLotes: data.totalLotes ?? null,
        totalRodeos: data.totalRodeos ?? null
    }
}
